module.exports = __webpack_public_path__ + "img/text-1.1101a116.svg";